import React from 'react';

import { StaffPermissionsModule } from 'src/modules';

// Company Admins is now an accordion — one row per admin, expanding into the
// module → role → permission editor.
export const EmployerStaffManagement: React.FC = () => <StaffPermissionsModule />;
